/* @flow */

import invariant from 'invariant';

const getElementoPorId = (id: string): HTMLElement => {
    const elemento = document.getElementById(id);
    invariant(elemento, `${id} não econtrado no documento`);
    return elemento;
};

export default getElementoPorId;
